/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetEvidenceRecords200ResponseInnerErrors } from './get-evidence-records200-response-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { GetEvidenceRecords200ResponseInnerFile } from './get-evidence-records200-response-inner-file';
// May contain unused imports in some cases
// @ts-ignore
import { GetEvidenceRecords200ResponseInnerInvoiceIssuer } from './get-evidence-records200-response-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { GetEvidenceRecords200ResponseInnerUpdatedBy } from './get-evidence-records200-response-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetEvidenceRecords200ResponseInnerUploadedBy } from './get-evidence-records200-response-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetEvidenceRecords200ResponseInnerWarnings } from './get-evidence-records200-response-inner-warnings';

/**
 * 
 * @export
 * @interface GetEvidenceRecords200ResponseInner
 */
export interface GetEvidenceRecords200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'evidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'paymentType': GetEvidenceRecords200ResponseInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'electronicMethod': GetEvidenceRecords200ResponseInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'documentSize': GetEvidenceRecords200ResponseInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'legalValidity': GetEvidenceRecords200ResponseInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetEvidenceRecords200ResponseInnerFile}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'file': GetEvidenceRecords200ResponseInnerFile;
    /**
     * 
     * @type {GetEvidenceRecords200ResponseInnerInvoiceIssuer}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'invoiceIssuer': GetEvidenceRecords200ResponseInnerInvoiceIssuer | null;
    /**
     * 
     * @type {GetEvidenceRecords200ResponseInnerErrors}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'errors': GetEvidenceRecords200ResponseInnerErrors;
    /**
     * 
     * @type {GetEvidenceRecords200ResponseInnerWarnings}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'warnings': GetEvidenceRecords200ResponseInnerWarnings;
    /**
     * 
     * @type {GetEvidenceRecords200ResponseInnerUpdatedBy}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'updatedBy': GetEvidenceRecords200ResponseInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetEvidenceRecords200ResponseInnerUploadedBy}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'uploadedBy': GetEvidenceRecords200ResponseInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'uploadedFrom': string;
}

export const GetEvidenceRecords200ResponseInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetEvidenceRecords200ResponseInnerPaymentTypeEnum = typeof GetEvidenceRecords200ResponseInnerPaymentTypeEnum[keyof typeof GetEvidenceRecords200ResponseInnerPaymentTypeEnum];
export const GetEvidenceRecords200ResponseInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidenceRecords200ResponseInnerElectronicMethodEnum = typeof GetEvidenceRecords200ResponseInnerElectronicMethodEnum[keyof typeof GetEvidenceRecords200ResponseInnerElectronicMethodEnum];
export const GetEvidenceRecords200ResponseInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidenceRecords200ResponseInnerDocumentSizeEnum = typeof GetEvidenceRecords200ResponseInnerDocumentSizeEnum[keyof typeof GetEvidenceRecords200ResponseInnerDocumentSizeEnum];
export const GetEvidenceRecords200ResponseInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetEvidenceRecords200ResponseInnerLegalValidityEnum = typeof GetEvidenceRecords200ResponseInnerLegalValidityEnum[keyof typeof GetEvidenceRecords200ResponseInnerLegalValidityEnum];


